import React from 'react'
import { FleetPage, Notice } from '../../../../shared/sso-workspace/fleet-page'

// A build with no REACT_APP_API_BILLING hides the section from the sidebar,
// but a typed address still lands on its pages: they say so instead of
// calling a service that is not there.
export const BillingUnavailable = ({ title = 'Billing' }) =>
  <FleetPage title={title}>
    <Notice tone="warn" role="alert">Billing isn't available in this environment.</Notice>
  </FleetPage>
